import { render } from "./Kassensystem.vue?vue&type=template&id=a67cf5f8&scoped=true"
import script from "./Kassensystem.vue?vue&type=script&lang=js"
export * from "./Kassensystem.vue?vue&type=script&lang=js"

import "./Kassensystem.vue?vue&type=style&index=0&id=a67cf5f8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a67cf5f8"]])

export default __exports__